import { render, staticRenderFns } from "./SelectDepend.vue?vue&type=template&id=a97488a8&"
import script from "./SelectDepend.vue?vue&type=script&lang=js&"
export * from "./SelectDepend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports